import React from "react";
import PropTypes from "prop-types";
import QualifiedFormatoDesktop from "./QualifiedFormatoDesktop";

function QualifiedFormato({ app, config }) {
  return <QualifiedFormatoDesktop app={app} config={config} />;
}

QualifiedFormato.defaultProps = {
  app: null,
  config: {},
};

QualifiedFormato.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default QualifiedFormato;
